import axios from "axios";

// Use REACT_APP_BACKEND_URL when set; otherwise default to same-origin so the
// app works correctly on both the preview URL and the deployed custom domain.
const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";
const BACKEND_URL =
  ENV_URL && ENV_URL.includes(window.location.hostname) ? ENV_URL : ORIGIN;

export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
